import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactGA from "react-ga4";
import { PageRoute } from "../../models/enums";
import { getImageLink } from "../../services/asset";
import { FeaturedStoreI } from "../../typings/interfaces";
import FollowStoreButton from "../FollowStoreButton";
import styles from "./featuredStoresWidget.scss";

interface Props {
  store: FeaturedStoreI;
  category?: string;
}

const FeaturedStoreCard = ({ store, category }: Props) => {
  const sellerUrl = `${PageRoute.user}/${encodeURIComponent(store.userName)}`;
  const logoUrl = getImageLink(store.avatarImage);
  const registeredLabel = `Registriran ${moment(store.registeredAt).format("DD.MM.YYYY.")}`;

  const handleStoreClick = () => {
    ReactGA.event({
      category: "Izdvojene trgovine naslovnica",
      action: "Click",
      label: `Klik na trgovinu - ${category || "nepoznato"}`
    });
  };

  return (
    <div className={styles.card}>
      <Link to={sellerUrl} className={styles.logoLink} onClick={handleStoreClick}>
        <div
          className={styles.logo}
          style={logoUrl ? { backgroundImage: `url(${logoUrl})` } : undefined}
        />
      </Link>
      <Link to={sellerUrl} className={styles.name} onClick={handleStoreClick}>
        {store.userName}
      </Link>
      <div className={styles.registered}>{registeredLabel}</div>
      <Link to={sellerUrl} className={styles.adsCount} onClick={handleStoreClick}>
        {store.activeAdsCount} oglasa
      </Link>
      <FollowStoreButton
        storeId={store.userId}
        className={styles.followButton}
        gaCategory="Izdvojene trgovine naslovnica"
        gaLabel={category || "nepoznato"}
      />
    </div>
  );
};

export default FeaturedStoreCard;



// WEBPACK FOOTER //
// ./src/components/FeaturedStoresWidget/FeaturedStoreCard.tsx